import './profile.less';

angular.module("tromanWeb").controller('ProfileController', ['accountServer', 'isTroman', 'dialogService', 'systemInfo', 'userProfile', function (accountServer, isTroman, dialogService, systemInfo, userProfile) {

    let self = this;

    function resetPasswordForm() {
        self.currentPassword = null;
        self.newPassword = null;
        self.confirmPassword = null;

        if (self.passwordform) {
            self.passwordform.$setPristine();
            self.passwordform.$setUntouched();
        }
    }

    this.systemInfo = systemInfo;
    this.profile = userProfile;
    this.passwordform = null;

    resetPasswordForm();

    this.getActiveRoles = function () {
        return isTroman ? userProfile.TromanRoles.display : userProfile.ValmanRoles.display;
    };

    this.canChangePassword = function () {
        if (!this.passwordform) return false;
        if (!this.passwordform.$valid) return false;

        return true;
    };

    this.changePassword = function () {
        if (!this.canChangePassword()) return;

        accountServer.Profile
            .changePassword(this.currentPassword, this.newPassword)
            .finally(() => {
                resetPasswordForm();
            })
            .then(() => {
                dialogService.notify('Lösenordet har ändrats.');
            })
            .catch(dialogService.error);
    };
}]);
